module.exports = __webpack_public_path__ + "img/10.4b5f367b.png";